'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getCodemirrorType } from 'DesignData/selectors/statusBar';
import FormattedMessage from 'I18n/components/FormattedMessage';
import StatusBarSection from 'DesignComponents/statusBar/StatusBarSection';
import * as TemplateFileTypes from 'DesignData/constants/TemplateFileTypes';

class StatusBarCodemirrorType extends PureComponent {
  render() {
    const {
      codemirrorType
    } = this.props;
    const assetTypesToExclude = Object.values(TemplateFileTypes);
    if (!codemirrorType || assetTypesToExclude.includes(codemirrorType)) return null;

    const label = /*#__PURE__*/_jsx(FormattedMessage, {
      message: `DesignEditorsUI.codeFileTypes.${codemirrorType}`
    });

    return /*#__PURE__*/_jsx(StatusBarSection, {
      alignRight: true,
      label: label
    });
  }

}

StatusBarCodemirrorType.propTypes = {
  codemirrorType: PropTypes.string
};

const mapStateToProps = state => {
  const codemirrorType = getCodemirrorType(state);
  return {
    codemirrorType
  };
};

export default connect(mapStateToProps, null)(StatusBarCodemirrorType);